<template>
  <svg :class="className" xmlns="http://www.w3.org/2000/svg" @click="onClick">
    <title v-if="title">{{ title }}</title>
    <use :xlink:href="iconPath" xmlns:xlink="http://www.w3.org/1999/xlink" />
  </svg>
</template>

<script>
export default {
  name: 'svg-icon',

  props: {
    prePath: {
      type: String
    },
    name: {
      type: String,
      required: true
    },

    title: {
      type: String,
      default: null
    }
  },

  computed: {
    iconPath() {
      let icon = require(`@/assets/${this.prePath ? `${this.prePath}/` : ''}${
        this.name
      }.svg`);
      if (Object.prototype.hasOwnProperty.call(icon, 'default')) {
        icon = icon.default;
      }

      return icon.url;
    },

    className() {
      return 'svg-icon svg-icon--' + this.name;
    }
  },
  methods: {
    onClick() {
      this.$emit('click')
    }
  }
};
</script>

<style>
.svg-icon {
  display: inline-block;
  fill: currentColor;
}
</style>
